import { render, staticRenderFns } from "./index-case.vue?vue&type=template&id=53746638&scoped=true&ref=indexCase&"
import script from "./index-case.vue?vue&type=script&lang=js&"
export * from "./index-case.vue?vue&type=script&lang=js&"
import style0 from "./index-case.vue?vue&type=style&index=0&id=53746638&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53746638",
  null
  
)

export default component.exports